import { useSuspenseQuery } from '@tanstack/react-query';

import { Id, useAppNotification } from '@feature/utils';
import { ValidationRequest, ValidationVariant } from '@feature/validation';
import { ValidationAction } from '@feature/validation/ValidationAction';

import {
  getGovAuthorEvaluationValidationOptions,
  useValidateGovAuthorEvaluation,
} from './model/GovAuthorEvaluationValidationModel';

interface ValidationActionProps {
  itemId: Id;
  variant?: ValidationVariant;
  onAfterValidation?: () => void;
}

export function GovAuthorEvaluationValidationAction({ itemId, variant, onAfterValidation }: ValidationActionProps) {
  const { data } = useSuspenseQuery(getGovAuthorEvaluationValidationOptions(itemId));
  const notification = useAppNotification();
  const { mutate, isPending } = useValidateGovAuthorEvaluation(itemId);

  const onSubmit = (request: ValidationRequest) => {
    mutate(request, {
      onSuccess: () => {
        notification.success();
        if (onAfterValidation) {
          onAfterValidation();
        }
      },
      onError: notification.error,
    });
  };

  return (
    <ValidationAction
      validation={data}
      isPending={isPending}
      onSubmit={onSubmit}
      variant={variant}
    />
  );
}
